export default __webpack_public_path__ + "static/patterns-d29321b3d4bec3902bb91b29a1f6b35b.webp";